import React, { useState, useEffect } from "react";
import { fetchApi } from "@globalholdings/ui-common-functions";
import {
  Box,
  ClickAwayListener,
  Popper,
  Container,
  styled,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { Grid, Typography } from "@material-ui/core";
import SvgIcon from "@material-ui/core/SvgIcon";
import { Apps } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";

const doNav = (p) => {
  window.open(p, "_blank");
};

const useStyles = makeStyles((theme) => ({
  apppicker: {
    paddingTop: "30px",
    paddingBottom: "30px",
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      background: theme.palette.primary.main,
      color: "#fff",
      cursor: "pointer",
    },
  },
  applicationItemGrid: {
    direction: "row",
  },
  applicationParentItem: {
    minWidth: "140px",
    flexGrow: 1,
  },
  applicationItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    "&:hover": {
      background: theme.palette.primary.main,
      color: "#fff",
      cursor: "pointer",
    },
  },
}));

const AppPicker = (props) => {
  const classes = useStyles();
  const [menuItems, setMenuItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(true);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((open) => !open);
  };

  const handleClickAway = () => {
    if (open) {
      setOpen(false);
    }
  };

  const createMenuItems = (data, queryString) => {
    var arr = [];
    for (var i = 0; i < data.length; i++) {
      data[i].qs = queryString;
      arr.push(data[i]);
    }
    setMenuItems(arr);
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const tokenExpirationDate = sessionStorage.getItem("expires");
    const username = sessionStorage.getItem("userName");
    const isAdUser = sessionStorage.getItem("isAdUser");
    const isTempPassword = sessionStorage.getItem("tempPass");
    const refreshToken = sessionStorage.getItem("refreshToken");

    if (isAdUser === "false" || !isAdUser) {
      setDisplay(false);
      return;
    }

    //This should hit an API endpoint and get a list of apps
    //Payload will contain the icon, app name, and any other relevant data
    let apps;
    fetchApi("GET", `${window.CONFIG.AUTH_API_URL}/auth/GetApplications`)
      .then((response) => {
        if (response.status === 200) {
          apps = response.data;
          if (response.data.length <= 0) {
          }
          const queryString = `accessToken=${accessToken}&expires=${tokenExpirationDate}&tokenExpirationDate=${tokenExpirationDate}&refreshToken=${refreshToken}&isTempPassword=${isTempPassword}&isAdUser=${isAdUser}&username=${username}`;
          createMenuItems(apps, queryString);
        } else {
          throw new Error(`Error Code ${response.status}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  function getNavUrl(application) {
    return application.link + "?" + application.qs;
  }

  return display ? (
    props.IsCompact ? (
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <Box display="flex" alignItems="center" textAlign="center">
            <Tooltip title="App Picker">
              <IconButton id={id} onClick={handleClick}>
                <Apps />
              </IconButton>
            </Tooltip>
          </Box>
          <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            transition
            modifiers={{
              offset: {
                enabled: true,
                offset: "0, 13",
              },
            }}
            style={{
              zIndex: 10000,
              maxWidth: "450px",
            }}
          >
            <Paper elevation={2}>
              <Grid container className={classes.applicationItemGrid}>
                {menuItems.map((row, index) => {
                  const icon = (
                    <SvgIcon>
                      <path d={`${row.path}`} />
                    </SvgIcon>
                  );

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      key={index}
                      className={classes.applicationParentItem}
                      onClick={(e) => doNav(getNavUrl(row))}
                    >
                      <Grid container className={classes.applicationItem}>
                        <Grid item>{icon}</Grid>
                        <Grid item>{row.label}</Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          </Popper>
        </div>
      </ClickAwayListener>
    ) : (
      <React.Fragment>
        <Paper elevation={2}>
          <Grid direction="row" container spacing={2}>
            {menuItems.map((row, index) => {
              const icon = (
                <SvgIcon>
                  <path d={`${row.path}`} />
                </SvgIcon>
              );

              return (
                <Grid
                  item
                  xs={12}
                  sm={4}
                  key={index}
                  className={classes.applicationParentItem}
                  onClick={(e) => doNav(getNavUrl(row))}
                >
                  <Grid container className={classes.applicationItem}>
                    <Grid item>{icon}</Grid>
                    <Grid item>{row.label}</Grid>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Paper>
      </React.Fragment>
    )
  ) : (
    ""
  );
};

export default AppPicker;
